export const batchUpdateLearningResourceMicrolearningStep = `
  updateLearningResourceMicroLearningStep(input: $learningResourceMicroLearningStepInput) {
  
    clientMutationId
    
    learningResourceMicroLearningStep {
      id
      order
    }
  
    errors {
      message
      path
    }
  
  }
`;
